<template>

    <div class="stages-detail-page admin-page">
        <Header></Header>
        <section class="contact-section">
            <div class="container">
                <div class="row">
                    <div class="col-md-5 text-left" style="margin: 0 auto 20px;">
                        <router-link class="next-icon add-btn" style="float: left;" :to="`/admin/artist/` + artistId + `/stages/`"><img src="@/assets/img/prev.svg"/> Stages</router-link>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-5" style="margin: 0 auto;">
                        <h2>Edit Stage</h2>
                        <form class="form" v-on:submit.prevent="uploadImgages" enctype="multipart/form-data">
                            <div class="input-field form-input">
                                <label for="your-title">Title *</label>
                                <input type="text" placeholder="Add a title" v-model="title" id="your-title" v-on:blur="titleFuntion(title)">
                                <p class="error-input" v-if="titleFlag">Title is required</p>
                            </div>
                            <div class="input-textarea-field form-input">
                                <label for="your-description">Stage Description *</label>
                                <textarea placeholder="Tell us about your stage..." id="your-description" v-model="description" v-on:blur="descriptionFuntion(description)" style="min-height: 150px;"></textarea>
                                <p class="error-input" v-if="descriptionFlag">Stage Description is required</p>
                            </div>
                            <div class="input-file-field form-input">
                                <p>Stage Image *</p>
                                <label for="video_image">
                                    <span>{{videoCoverImage}}</span>
                                    <span>Choose File</span>
                                </label>
                                <input type="file" id="video_image" ref="videoImageFile" v-on:change="handleVideoCoverUpload">
                            </div>
                            <div class="input-field form-input">
                                <label for="event-location">Event Location *</label>
                                <input type="text" placeholder="Add a event location" v-model="eventLocation" id="event-location" v-on:blur="eventLocationFuntion(eventLocation)">
                                <p class="error-input" v-if="eventLocationFlag">Event Location is required</p>
                            </div>
                            <div class="input-field form-input">
                                <label>Event Date *</label>
                                <datepicker placeholder="Event Date" v-model="date" @selected="dateSelected" id="event-date" format="MMMM d yyyy" required></datepicker>
                            </div>
                            <div class="input-field form-input" v-if="pastEvent">
                                <label for="youtubeurl">You Tube Link *</label>
                                <input type="text" placeholder="You Tube Link" v-model="youtubeurl" id="youtubeurl" v-on:blur="youtubeurlFuntion(youtubeurl)">
                                <p class="error-input" v-if="youtubeurlFlag">You tube link is required</p>
                            </div>
                            <div class="input-field form-input">
                                <label for="rehersal-schedule">Rehersal Schedule *</label>
                                <input type="text" placeholder="Once a month" v-model="rehersalSchedule" id="rehersal-schedule" v-on:blur="rehersalScheduleFuntion(rehersalSchedule)">
                                <p class="error-input" v-if="rehersalScheduleFlag">Rehersal Schedule is required</p>
                            </div>

                            <div class="input-tags-field form-input">
                                <label>Tag <span></span></label>
                                <tags-input element-id="tags"
                                            v-model="selectedSkills"
                                            :only-existing-tags="true"
                                            :delete-on-backspace="true"
                                            :typeahead-hide-discard="true"
                                            placeholder="Add your skills"
                                            @tags-updated="skillsFuntion"
                                            :existing-tags="[
                                                { key: 'Art', value: 'Art' },
                                                { key: 'Dance', value: 'Dance' },
                                                { key: 'Music', value: 'Music' },
                                                { key: 'Other', value: 'Other' },
                                            ]"
                                            :typeahead="true"></tags-input>
                            </div>
                            <div class="input-field form-input">
                                <label for="isfeatured">Is Featured</label>
                                <input type="checkbox" v-model="isfeatured" id="isfeatured">
                            </div>
                            <div class="modal-field form-input">
                                <label>Team Memebers Role *</label>
                                <a href="javascript:void(0)" data-toggle="modal" data-target="#teamrolemodal"><img src="@/assets/img/plus.svg"/> Add team members</a>
                                <div class="row role-heading" v-if="roleList">
                                    <div class="col-md-4">
                                        <h3>Role</h3>
                                    </div>
                                    <div class="col-md-4">
                                        <h3>Specialty</h3>
                                    </div>
                                    <div class="col-md-4">
                                        <h3>Remote/Local</h3>
                                    </div>
                                </div>
                                <div class="row role-choosed" v-if="roleList && !list.action" v-for="(list, index) in roleList" v-bind:key="index">
                                    <div class="col-md-4">
                                        <h4>{{list.role}}</h4>
                                    </div>
                                    <div class="col-md-4">
                                        <h4 v-if="list.specialty">{{list.specialty}}</h4>
                                        <h4 v-if="!list.specialty">-</h4>
                                    </div>
                                    <div class="col-md-4">
                                        <h4 v-if="list.remote">Remote</h4>
                                        <h4 v-if="!list.remote">Local</h4>
                                    </div>
                                </div>
                            </div>
                            <div class="edit-stage-team">
                                <h3>Team Members <a href="javascript:void(0)" class="add-mem" data-toggle="modal" data-target="#teammemmodal"><img src="@/assets/img/plus.svg"/> Link Artists</a></h3>
                                <ul class="team-member-list"  v-if="memebrs.length">
                                    <li v-if="memebrs" v-for="(list, index) in memebrs" v-bind:key="index">
                                        <div class="row">
                                            <div class="col-md-8">
                                                <div class="member-img background-fit" :style="{ backgroundImage: `url(${imageUrl + list.profiles[0].images[0].profileImageFile})` }"></div>
                                                <div class="member-detail">
                                                    <h3 style="font-weight: 600;">{{list.name}}</h3>
                                                    <h4>{{list.role}} from {{list.profiles[0].location}}</h4>
                                                </div>
                                            </div>
                                            <div class="col-md-4 text-right">
                                                <a href="javascript:void(0)" class="remove-blk" v-on:click="removeMember" :data-appliedArtist="list._id" :data-roleId="list.roleId">Remove</a>
                                                <span class="member-role" style="padding: 10px;">{{list.role}}</span>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                                <ul class="team-member-list"  v-if="tempMembers && tempMembers.length">
                                    <li v-if="tempMembers" v-for="(list, index) in tempMembers" v-bind:key="index" style="background-color: rgba(150,107,137,0.4);">
                                        <div class="row">
                                            <div class="col-md-8">
                                                <div class="member-img background-fit"></div>
                                                <div class="member-detail">
                                                    <h3 style="font-weight: 600;">{{list.email}}</h3>
                                                </div>
                                            </div>
                                            <div class="col-md-4 text-right">
                                                <a href="javascript:void(0)" class="remove-blk" :data-id="list._id" data-toggle="modal" data-target="#deleteModal" v-on:click="deleteFunction">Remove</a>
                                                <span class="member-role" style="padding: 10px;">{{list.roleId.role}}</span>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                            <div class="input-textarea-field form-input">
                                <progress-bar
                                        v-if="progressFlag"
                                        :options="options"
                                        :value="value"
                                />
                            </div>
                            <div class="input-submit">
                                <button type="submit" v-if="!FormSubmited">SUBMIT</button>
                                <span v-if="FormSubmited">SUBMIT...</span>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </section>
        <!-- Modal -->
        <div class="modal fade" id="teamrolemodal" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalCenterTitle">Add Team Members</h5>
                    </div>
                    <div class="modal-body">
                        <div class="row team-role-heading">
                            <div class="col-md-4">
                                <h3>Role</h3>
                            </div>
                            <div class="col-md-4">
                                <h3>Specialty</h3>
                            </div>
                            <div class="col-md-4">
                                <h3>Remote</h3>
                            </div>
                        </div>
                        <TeamRole @clicked="removeOne" :count="list" v-for="(list) in roleList" v-bind:key="list._id" />
                        <TeamRoleCreate @clicked="removeOne" :count="list" v-for="(list) in roleCount" v-bind:key="list" />
                        <a href="javascript:void(0)" class="add-more-role" v-on:click="addMore">Add additional team member</a>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                        <button type="button" class="btn btn-primary" data-dismiss="modal" v-on:click="saveChanges">Save changes</button>
                    </div>
                </div>
            </div>
        </div>
        <!-- Modal -->
        <div class="modal fade" id="teammemmodal" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Add Team Members</h5>
                    </div>
                    <div class="modal-body">
                        <div class="row form invite-email-blk">
                            <div class="col-md-5">
                                <input type="text" v-model="inviteEmail" placeholder="Enter Email" />
                            </div>
                            <div class="col-md-5">
                                <div class="input-select-field form-input">
                                    <select v-model="inviteRole">
                                        <option v-for="list1 in roleList" :value="list1._id">{{list1.role}}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-md-2 input-submit">
                                <a href="javascript:void(0)" class="invite-btn" v-on:click="inviteMember">{{inviteText}}</a>
                            </div>
                        </div>
                        <div class="row" v-for="(list) in newArtists" v-if="newArtists && list.profiles[0].profession" v-bind:key="list._id">
                            <div class="col-md-5 r-p">
                                <div class="p-img background-fit" :style="{ backgroundImage: `url(${imageUrl + list.profiles[0].images[0].profileImageFile})` }"></div>
                                <h3>{{list.name}}</h3>
                            </div>
                            <div class="col-md-5">
                                <div class="input-select-field form-input">
                                    <select>
                                        <option v-for="list1 in roleList" :value="list1._id">{{list1.role}}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-md-2 se-c text-right">
                                <label :for="`remote_checkbox_`+list._id" :data-artistId="list._id" :data-stageId="stageId" v-on:click="chooseMember">
                                    <img src="@/assets/img/check_mark.png" width="45" />
                                </label>
                                <input class="checkbox-remote" type="checkbox" :id="`remote_checkbox_`+list._id"  />
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                        <button type="button" class="btn btn-primary" v-on:click="saveMemebers">Save changes</button>
                    </div>
                </div>
            </div>
        </div>
        <Footer :dataId="deleteRecord" :dataModel="model"></Footer>
    </div>
</template>
<style>
    @import "../../../assets/css/tagsinput.css";
</style>

<script>
    import Vue from 'vue'
    import Header from '../Header'
    import Footer from '../Footer'
    import TeamRole from '../../include/TeamRole'
    import TeamRoleCreate from '../../include/TeamRoleCreate'
    import emailImage from '@/assets/img/email/img1.png'
    import router from '../../../router'
    import $ from "jquery"
    import VueInsProgressBar from 'vue-ins-progress-bar'
    import VoerroTagsInput from '@voerro/vue-tagsinput'
    import moment from 'moment'
    import Datepicker from 'vuejs-datepicker'
    import axios from 'axios'
    import VueToast from 'vue-toast-notification'
    import 'vue-toast-notification/dist/index.css'
    Vue.use(VueToast)

    export default {
        name: 'AdminEditUpcomingStage',
        components: {
            'Header': Header,
            'Footer': Footer,
            'TeamRole': TeamRole,
            'TeamRoleCreate': TeamRoleCreate,
            'Datepicker': Datepicker,
            'tags-input': VoerroTagsInput
        },
        data () {
            var userdata = localStorage.getItem('cbs_admin_usertoken')
            if(userdata){
                userdata = JSON.parse(userdata)
            } else {
                router.push({ name: 'Login' })
            }
            var options = {
                text: {
                    color: '#FFFFFF',
                    shadowEnable: true,
                    shadowColor: '#000000',
                    fontSize: 14,
                    fontFamily: 'Helvetica',
                    dynamicPosition: false,
                    hideText: false
                },
                progress: {
                    color: '#2dbd2d',
                    backgroundColor: '#333333'
                },
                layout: {
                    height: 35,
                    width: 445,
                    verticalTextAlign: 61,
                    horizontalTextAlign: 43,
                    zeroOffset: 0,
                    strokeWidth: 30,
                    progressPadding: 0,
                    type: 'line'
                }
            }
            return {
                msg: 'Welcome to Your Vue.js App',
                value: 1,
                options: options,
                progressFlag: false,
                roleCount: 1,
                choosedMemberList: '',
                inviteText: 'Invite',
                inviteEmail: '',
                emailImage: emailImage,
                selectedSkills: [],
                deleteRecord: '',
                model: 'Temp',
                inviteRole: '',
                tempMembers: '',
                roleList: '',
                stageId: router.history.current.params.id,
                artistId: router.history.current.params.userId,
                date: '',
                tags: '',
                isfeatured: false,
                title: '',
                youtubeurl: '',
                youtubeurlFlag: false,
                pastEvent: true,
                userData: userdata,
                titleFlag: false,
                eventLocation: '',
                eventLocationFlag: false,
                rehersalSchedule: '',
                rehersalScheduleFlag: false,
                description: '',
                memebrs: '',
                memebrsId: '',
                newArtists: '',
                artists: '',
                descriptionFlag: false,
                stageid: '',
                videoFile: 'Video file',
                FormSubmited: false,
                // videoImageFile: '',
                videoId: '',
                imageUrl: process.env.imageUrl,
                videoCoverImage: 'Image file',
                userId: userdata.user.id,
                userName: userdata.user.name
            }
        },
        mounted () {
            axios
                .get('/getStageById', {
                    params: {
                        stageId: this.stageId
                    }
                })
                .then(response => {
                    console.log(response)
                    let currentDate = moment(new Date()).format('YYYYMMDD')
                    let eventDate = moment(response.data.date).format('YYYYMMDD')
                    if(parseInt(eventDate) > parseInt(currentDate)){
                        this.pastEvent = false
                    }
                    this.title = response.data.title
                    this.youtubeurl = response.data.youtubeurl
                    this.isfeatured = response.data.isfeatured
                    this.date = response.data.date
                    this.created = response.data.created
                    this.rehersalSchedule = response.data.rehersalSchedule
                    this.name = response.data.userId[0].name
                    this.profileImage = response.data.userId[0].profiles[0].images[0].profileImageFile
                    if(response.data.videoId[0].videoImageFile){
                        this.videoCoverImage = response.data.videoId[0].videoImageName
                    }
                    this.videoId = response.data.videoId[0]._id
                    // this.videoCoverImage = response.data.videoId[0].videoImageFile
                    // this.video = this.imageUrl + response.data.videoId[0].videourl
                    this.description = response.data.description
                    this.eventLocation = response.data.eventLocation
                    if(response.data.tags){
                        var list = []
                        response.data.tags.map(function(value, key) {
                            list.push({key: value, value: value})
                        })
                    }
                    this.selectedSkills = list
                    var tags = []
                    this.selectedSkills.map(function(value, key) {
                        tags.push(value.value)
                    })
                    this.tags = tags
                    this.ownerId = response.data.userId[0]._id
                    var userData = localStorage.getItem('cbs_usertoken')
                    if(userData){
                        userData = JSON.parse(userData)
                        this.logedIn = true
                    } else {
                        this.logedIn = false
                    }
                    if(response.data.appliedArtist && userData){
                        if(response.data.appliedArtist.indexOf(userData.user.id) >= 0){
                            this.applyStageFlag = true
                        } else {
                            this.applyStageFlag = false
                        }
                    }

                })
                .catch(error => console.log(error))
            axios
                .get('/getMembers', {
                    params: {
                        stageId: this.stageId
                    }
                })
                .then(response => {
                    this.roleList = response.data
                    this.roleCount = 0
                    console.log(this.roleCount)
                    let memebrs = []
                    let memebrsId = []
                    $.each(response.data, function(key, value) {
                        if(value.appliedArtist.length){
                            $.each(value.appliedArtist, function(key1, value1) {
                                value1.role = value.role
                                value1.roleId = value._id
                                memebrs.push(value1)
                                memebrsId.push(value1._id)
                            })
                        }
                    })
                    this.memebrs = memebrs
                    this.memebrsId = memebrsId
                    console.log('members', memebrs)
                    // console.log(response.data)

                })
                .catch(error => console.log(error))

            axios
                .get('/artists', {})
                .then(response => {
                    let $this = this
                    let newArtist = []
                    this.artists = response.data
                    this.artists.map(function (value, key) {
                        if(!$this.memebrsId.includes(value._id)){
                            newArtist.push(value)
                        }
                    })
                    this.newArtists = newArtist
                })
                .catch(error => console.log(error))

            axios
                .get('/getTempMembersByStageId', {
                    params: {
                        stageId: this.stageId
                    },
                    headers: {
                        "content-type": "application/json",
                        "x-api-key": this.userData.token
                    }
                })
                .then(response => {
                    this.tempMembers = response.data
                })
                .catch(error => console.log(error))
        },
        methods: {
            dateSelected: function(event){
                let selectedDate = moment(event).format('YYYYMMDD')
                let currentDate = moment(new Date()).format('YYYYMMDD')
                if(parseInt(currentDate) > parseInt(selectedDate)){
                    this.pastEvent = true
                } else {
                    this.pastEvent = false
                }
            },
            inviteMember: function(event){
                this.inviteText = 'Inviting...'
                axios.post('/addMemeberInTemp', {
                    email: this.inviteEmail,
                    roleId: this.inviteRole,
                    userId: this.userId,
                    userName: this.userName,
                    emailImage: this.emailImage,
                    stageId: this.stageId
                },{
                    headers: {
                        "content-type": "application/json",
                        "x-api-key": this.userData.token
                    }
                }).then(res => {
                    this.inviteText = 'Invite'
                    if(res.data == 'exist'){
                        Vue.$toast.open(
                            {
                                message: 'User Exists!',
                                type: 'error',
                                position: 'top-right'
                                // all other options
                            }
                        )
                    } else {
                        location.reload()
                    }
                }).catch(err => {
                    this.inviteText = 'Invite'
                    Vue.$toast.open(
                        {
                            message: 'Something goes wrong!',
                            type: 'error',
                            position: 'top-right'
                            // all other options
                        }
                    )
                    console.log(err)
                })
            },
            activeFuntion: function(event){
                $(event.target).toggleClass('active-checkbox')
            },
            chooseMember: function(event){
                $(event.target).toggleClass('active-checkbox')
                var mBlock = []
                var mObject = {}
                $('#teammemmodal .active-checkbox').each(function () {
                    mObject = {
                        artistId: $(this).closest('label').attr('data-artistId'),
                        stageId: $(this).closest('label').attr('data-stageId'),
                        roleId: $(this).closest('.row').find('select').val()
                    }
                    mBlock.push(mObject)
                })
                this.choosedMemberList = mBlock
            },
            skillsFuntion(msg){
                if (!this.selectedSkills.length) {
                    this.skillsFlag = true
                } else {
                    this.skillsFlag = false
                    var tags = []
                    this.selectedSkills.map(function(value, key) {
                        tags.push(value.value)
                    })
                    this.tags = tags
                }
            },
            removeMember: function(event){
                $(event.target).text('Remove...')
                axios.post('/removeMemeberFromStage', {
                    appliedartist: event.target.dataset.appliedartist,
                    roleid: event.target.dataset.roleid,
                    stageId: this.stageId
                },{
                    headers: {
                        "content-type": "application/json",
                        "x-api-key": this.userData.token
                    }
                }).then(res => {
                    $(event.target).closest('li').detach()
                    Vue.$toast.open(
                        {
                            message: 'Member removed successfully',
                            type: 'success',
                            position: 'top-right'
                            // all other options
                        }
                    )
                }).catch(err => {
                    $(event.target).text('Remove')
                    Vue.$toast.open(
                        {
                            message: 'Something goes wrong!',
                            type: 'error',
                            position: 'top-right'
                            // all other options
                        }
                    )
                    console.log(err)
                })
            },
            deleteFunction(e) {
                this.deleteRecord = e.target.dataset.id
            },
            youtubeurlFuntion(msg){
                if (!msg) {
                    this.youtubeurlFlag = true
                } else {
                    this.youtubeurlFlag = false
                }
            },
            saveChanges: function(){
                var roleBlock = []
                var roleObject = {}
                $('.role-blk').each(function () {
                    roleObject = {
                        _id: $(this).find('select').data('id'),
                        role: $(this).find('select').val(),
                        specialty: $(this).find('.specialty').val(),
                        remote: $(this).find('.active-checkbox').length,
                        action: $(this).data('action')
                    }
                    roleBlock.push(roleObject)
                })
                this.roleList = roleBlock
                console.log(this.roleList)
                // localStorage.setItem('cbs_roleData', JSON.stringify(roleBlock))
            },
            saveMemebers: function(){
                if(this.choosedMemberList){
                    $(event.target).text('Saving...')
                    axios.post('/addMemeberFromStage', {
                        choosedMemberList: this.choosedMemberList
                    },{
                        headers: {
                            "content-type": "application/json",
                            "x-api-key": this.userData.token
                        }
                    }).then(res => {
                        location.reload()
                        $(event.target).text('Save Change')
                        Vue.$toast.open(
                            {
                                message: 'Member added successfully',
                                type: 'success',
                                position: 'top-right'
                                // all other options
                            }
                        )
                    }).catch(err => {
                        $(event.target).text('Save Change')
                        Vue.$toast.open(
                            {
                                message: 'Something goes wrong!',
                                type: 'error',
                                position: 'top-right'
                                // all other options
                            }
                        )
                        console.log(err)
                    })
                }
            },
            addMore: function (event){
                this.roleCount = parseInt(this.roleCount) + 1
            },
            removeOne: function (event){
                $(event.target).closest('.role-blk').attr('data-action', 'delete').hide()
            },
            progressDelay: function(){
                var numberOfTimes = ''
                var delay = ''
                var $this = this
                if(this.value === 1){
                    numberOfTimes = 98
                    delay = 300
                } else {
                    numberOfTimes = 100 - this.value
                    delay = 10
                }
                for (let i = 0; i < numberOfTimes; i++) {
                    setTimeout( function () {
                        if($this.value < 100){
                            $this.value = $this.value + 1
                        }
                    }, delay * i)
                }
            },
            titleFuntion(msg){
                if (!msg) {
                    this.titleFlag = true
                } else {
                    this.titleFlag = false
                }
            },
            eventLocationFuntion(msg){
                if (!msg) {
                    this.eventLocationFlag = true
                } else {
                    this.eventLocationFlag = false
                }
            },
            rehersalScheduleFuntion(msg){
                if (!msg) {
                    this.rehersalScheduleFlag = true
                } else {
                    this.rehersalScheduleFlag = false
                }
            },
            descriptionFuntion(msg){
                if (!msg) {
                    this.descriptionFlag = true
                } else {
                    this.descriptionFlag = false
                }
            },
             createStageForm(){
                 this.FormSubmited = true
                 this.progressFlag = true
                try {
                    axios.post('/editstage', {
                        title: this.title,
                        description: this.description,
                        eventLocation: this.eventLocation,
                        rehersalSchedule: this.rehersalSchedule,
                        date: this.date,
                        tags: this.tags,
                        isfeatured: this.isfeatured,
                        youtubeurl: this.youtubeurl,
                        roleList: this.roleList,
                        videoId: this.videoId,
                        userId: this.artistId,
                        stageId: this.stageId
                    },{
                        headers: {
                            "content-type": "application/json",
                            "x-api-key": this.userData.token
                        }
                    }).then(res => {
                        this.FormSubmited = false
                        this.progressDelay()
                        this.progressFlag = false
                        this.value = 1
                        Vue.$toast.open(
                            {
                                message: 'Stage updated!',
                                type: 'success',
                                position: 'top-right'
                                // all other options
                            }
                        )
                        location.reload()
                    }).catch(err => {
                        this.progressFlag = false
                        this.value = 1
                        this.FormSubmited = false
                        console.log(err)
                    })
                } catch (e) {
                    this.FormSubmited = false
                    console.log(e)
                }
            },
            handleFileUpload(){
                this.file = this.$refs.file.files[0]
                this.videoFile = this.$refs.file.files[0].name
                console.log(this.$refs.file.files[0].name)
            },
            handleVideoCoverUpload(){
                this.videoImageFile = this.$refs.videoImageFile.files[0]
                this.videoCoverImage = this.$refs.videoImageFile.files[0].name
                console.log(this.$refs.videoImageFile.files[0].name)
            },
            async uploadImgages () {
                if(this.videoImageFile){
                    this.FormSubmited = true
                    this.progressFlag = true
                    this.progressDelay()
                    const formData = new FormData()
                    // formData.append('videourl', this.file)
                    formData.append('videoImageFile', this.videoImageFile)
                    // formData.append('videoName', this.videoFile)
                    formData.append('videoImageName', this.videoCoverImage)
                    formData.append('videoId', this.videoId)
                    try {
                        axios.post('/stageVideoEdit', formData,{
                            headers: {
                                "content-type": "application/json",
                                "x-api-key": this.userData.token
                            }
                        }).then(res => {
                            this.videoId = res.data.videoId
                            this.createStageForm()
                            console.log(res)
                        }).catch(err => {
                            console.log(err)
                        })
                    } catch (e) {
                        console.log(e)
                    }
                } else {
                    this.createStageForm()
                    // Vue.$toast.open(
                    //     {
                    //         message: 'Please fill all the fields!',
                    //         type: 'error',
                    //         position: 'top-right'
                    //         // all other options
                    //     }
                    // )
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/admin/stages/EditUpcomingStage.vue